import { adjustToken } from '../constants'
import { isInNativeApp } from 'web-utils/device'
import Adjust from '@adjustcom/adjust-web-sdk'
import { getAdjustEnv } from '@/utils'
import { queryURLParams } from 'web-utils/url'

function main() {
  const advertiseType = import.meta.env.VITE_AD
  if (advertiseType || isInNativeApp() || !adjustToken) {
    return
  }
  const config = {
    appToken: adjustToken,
    environment: getAdjustEnv(),
    logLevel: 'verbose'
  }
  Adjust.initSdk(config)
  const adjustReferrer = queryURLParams('adjust_referrer')
  if (!adjustReferrer) {
    return
  }
  let referrer = adjustReferrer
  if (referrer.includes('=')) {
    referrer = encodeURIComponent(referrer)
  }
  Adjust.setReferrer(referrer)
}

main()
